import { render, staticRenderFns } from "./page-order-money.vue?vue&type=template&id=3d6fca89&scoped=true"
import script from "./page-order-money.vue?vue&type=script&lang=js"
export * from "./page-order-money.vue?vue&type=script&lang=js"
import style0 from "./page-order-money.vue?vue&type=style&index=0&id=3d6fca89&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6fca89",
  null
  
)

export default component.exports